<div class="filter-element d-none d-md-flex">
  <button class="btn btn-primary btn-block mr-2" type="button" (click)="onRefresh()" [disabled]="disableRefreshButton">
    <span class="fa-solid fa-arrows-rotate"></span>
    <span translate>Refresh</span>
  </button>

  <div #dropdownStatus="ngbDropdown" ngbDropdown>
    <button class="btn btn-outline-primary mr-2" id="dropdownStatus" ngbDropdownToggle>
      <span class="fa-solid fa-filter"></span>
      <span translate>Filter</span>
    </button>

    <div aria-labelledby="dropdownManual" class="p-3" ngbDropdownMenu style="min-width: 200px;">

      <h6 class="dropdown-header px-0" translate>Show types</h6>

      <div class="checkbox-list">
        <div class="d-flex align-items-center text-success mb-2">
          <input (change)="onFiltersChange($event, ConnectionStatusEnum.CONNECTED)"
                 [checked]="showConnectStatuses"
                 id="errorCheckbox"
                 type="checkbox"
                 class="mr-2">
          <label for="errorCheckbox" class="mb-0">
            <span translate>Connected</span>
            <span class="fa-solid fa-circle-check ml-1"></span>
          </label>
        </div>

        <div class="d-flex align-items-center text-danger mb-2">
          <input (change)="onFiltersChange($event, ConnectionStatusEnum.DISCONNECTED)"
                 [checked]="showDisconnectStatuses"
                 id="warningCheckbox"
                 type="checkbox"
                 class="mr-2">
          <label for="warningCheckbox" class="mb-0">
            <span translate>Disconnected</span>
            <span class="fa-solid fa-circle-exclamation ml-1"></span>
          </label>
        </div>
      </div>

      <button (click)="onFilterByStatusType(); dropdownStatus.close();" class="btn btn-block btn-primary" translate>
        Apply
      </button>
    </div>
  </div>

  <div #dropDownTableau="ngbDropdown" ngbDropdown>
    <button (focus)="dropDownTableau.open()"
            class="btn btn-outline-primary"
            id="dropDownTableau" ngbDropdownAnchor>
      <span translate>Functions</span>
    </button>

    <div aria-labelledby="dropDownTableau" ngbDropdownMenu>
      <button (click)="onExportCSV()" [disabled]="disableCSVExportButton" ngbDropdownItem>
        <span class="fa-solid fa-file-csv"></span>
        <span translate>Export CSV</span>
      </button>
    </div>
  </div>
</div>
